import React from 'react';
import TitleReview from '../Reviews/TitleReview';
import LaneContainer from '../UI/LaneContainer';
import { useTitle } from './containers/TitleDataStore';
import CommunityButton from '../UI/CommunityButton';
import ReviewEditorAnchor from '../Reviews/ReviewEditor/ReviewEditorAnchor';
import UserReviewEditorProvider from '../Reviews/ReviewEditor/data/UserReviewEditorProvider';
import { useReviews } from '../Reviews/containers/ReviewsDataStore';
import PropTypes from 'prop-types';
import MuchLoveAnchor from '../Reviews/ReviewEditor/MuchLove/MuchLoveAnchor';
import { useUser } from '../User/containers/UserDataStore';
import { useAccountOrMembershipRequiredModalContext } from '../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';

TitleYourReview.propTypes = {
	sku: PropTypes.string,
};

export default function TitleYourReview({ sku }) {
	const {
		isReviewDataLoading,
		review,
		isProductDataLoading,
		refreshReview,
	} = useTitle();
	const { refresh } = useReviews();
	const { isAnonymous } = useUser();
	const { setIsVisible } = useAccountOrMembershipRequiredModalContext();

	const refreshReviewInfo = () => {
		refreshReview();
		refresh();
	};

	const renderCommunityButton = () => {
		return (
			<CommunityButton
				text={review && review.assessmentId > 0 ? 'Edit' : 'Write'}
				icon="icon-review-icon"
				iconClass="add-review"
			/>
		);
	};

	const renderMuchLoveAnchor = () => {
		return (
			<MuchLoveAnchor
				rating={review && review.overallAssessment}
				sku={sku}
				onUpdate={refreshReviewInfo}
			/>
		);
	};

	const renderLaneExtra = () => {
		return isAnonymous() ? (
			<div style={{ display: 'flex' }} onClick={() => setIsVisible(true)}>
				{renderCommunityButton()}
				{renderMuchLoveAnchor()}
			</div>
		) : (
			<div style={{ display: 'flex' }}>
				<ReviewEditorAnchor sku={sku} onUpdate={refreshReview}>
					{renderCommunityButton()}
				</ReviewEditorAnchor>
				<UserReviewEditorProvider
					sku={sku}
					onUpdate={refreshReview}
					shareTargetsOptions={{ doIncludeGenreCommunities: false }}>
					{renderMuchLoveAnchor()}
				</UserReviewEditorProvider>
			</div>
		);
	};

	return (
		<div>
			<LaneContainer
				majorHeader="Your Review"
				icon="review-icon"
				extra={
					!isProductDataLoading &&
					!isReviewDataLoading &&
					renderLaneExtra()
				}>
				{!isReviewDataLoading && review && review.assessmentId > 0 && (
					<div
						style={{
							marginTop: '5px',
							marginBottom: '10px',
							marginRight: '20px',
						}}>
						<TitleReview
							review={review}
							source={'titleDetail'}
							communityId={0}
						/>
					</div>
				)}
			</LaneContainer>
		</div>
	);
}
